import React from 'react';
import PropTypes from 'prop-types';

import { Spacer } from '@kueski-dev/kueski-design-system';

import Urls from 'Containers/Urls';

import { ButtonContainer, TextBreak } from './ButtonHome.styles';
import IconHome from './icon-home.svg';

export const ButtonHome = ({
  className,
  linkText,
  link,
  openInSelf,
  onClick,
}) => {
  const handleClick = () => {
    if (typeof trackEvent === 'function') {
      onClick();
    }
    if (openInSelf) return window.open(link, '_self');

    return window.open(link, '_blank');
  };
  return (
    <ButtonContainer className={className} onClick={handleClick} role="button">
      <IconHome />
      {
        Boolean(linkText) && (
          <>
            <Spacer $size="layout01" />
            <TextBreak $format="Title/Small/Bold" $color="textPrimary" $align="center">{linkText}</TextBreak>
          </>
        )
      }
    </ButtonContainer>
  );
};

ButtonHome.defaultProps = {
  className: '',
  link: Urls.home,
  linkText: 'Ir a inicio',
  onClick: () => {},
  openInSelf: false,
};

ButtonHome.propTypes = {
  className: PropTypes.string,
  link: PropTypes.string,
  linkText: PropTypes.string,
  onClick: PropTypes.func,
  openInSelf: PropTypes.bool,
};
